import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';

import InfoIcon from '@/assets/icons/info-icon.svg';
import SuccessIcon from '@/assets/icons/success-icon.svg';

import { isBrowser } from '../../../helpers/is-browser';
import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import ImageWrapper from '../../image-wrapper/Image-wrapper';
import { RichText } from '../../rich-text/rich-text';
import Button from '../../ui/button/button';
import {
  useGetLibraryConstantsDictionaryData,
  useIsMPLivliFamily,
} from '@/providers/ConfigProvider';
import { useUser } from '@/providers/UserProvider';

interface DynamicOfferRedemptionProps {
  className?: string;
  offerRedemptionDetails?: {
    internalName: string;
    richText: any;
  };
  handleClose: () => void;
  tenantDetails: {
    offerName?: string;
    tenantName?: string;
    tenantLogo?: IContentfulImage;
  };
  node_locale: string;
  contentful_id?: string;
}

export const DynamicOfferRedemption = ({
  className,
  offerRedemptionDetails,
  handleClose,
  tenantDetails,
  node_locale,
  contentful_id,
}: DynamicOfferRedemptionProps) => {
  const isLivliFamily = useIsMPLivliFamily();
  const dictionary = useGetLibraryConstantsDictionaryData();
  const { user } = useUser();

  useEffect(() => {
    sendGtmEvent();
  }, []);

  const sendGtmEvent = () => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'offer_redemption',
        contentful_id: contentful_id,
        name: tenantDetails?.offerName,
        success: true,
        user_status: isLivliFamily ? 'logged_in' : undefined,
      });
    }
  };

  return (
    <div className="flex flex-col justify-between items-center h-full">
      <div className="w-full">
        <div className="text-headingm font-title gap-4 text-neutral-grey-700 text-center flex justify-center items-center flex-col">
          <SuccessIcon />
          {dictionary?.specialOfferClaimedOfferText}
        </div>
        <div className="text-center text-bodyxl text-neutral-grey-700 flex-col">
          {DateTime.now().toFormat('dd LLL, yyyy')}
          {' | '}
          {DateTime.now().toFormat('HH:mm:ss')}
        </div>
        <div className="bg-brand-blue-1/30 text-bodys font-sans text-brand-blue-3 rounded-md py-1 flex gap-2 pl-3 my-6">
          <InfoIcon /> <p>{dictionary?.dynamicOfferInfoText}</p>
        </div>
        <div className="flex mt-4">
          {tenantDetails?.tenantLogo && (
            <ImageWrapper
              url={tenantDetails?.tenantLogo?.url}
              alt={
                tenantDetails?.tenantLogo?.description
                  ? tenantDetails?.tenantLogo.description
                  : ''
              }
              className="h-12 w-12 lg:h-16 lg:w-16 rounded-md bg-brand-white flex border border-brand-grey-2"
              imgClassName="!object-contain rounded-md"
              width={
                tenantDetails?.tenantLogo?.width
                  ? parseInt(tenantDetails?.tenantLogo?.width)
                  : undefined
              }
              height={
                tenantDetails?.tenantLogo?.height
                  ? parseInt(tenantDetails?.tenantLogo?.height)
                  : undefined
              }
            />
          )}
          <div className="ml-4 text-neutral-grey-700 font-sans">
            <div className="text-bodyl text-text-default">
              {tenantDetails?.tenantName}
            </div>
            <div className="text-bodyl font-bold">
              {tenantDetails?.offerName}
            </div>
          </div>
        </div>
        {offerRedemptionDetails && (
          <div className="card w-[100%] overflow-y-scroll max-h-[23.5vh] flex flex-col align-centre items-center bg-background-primary rounded-md p-4 mt-6">
            <RichText
              richText={offerRedemptionDetails?.richText}
              assetClass={'w-[150px] h-[150px] mb-0'}
            />
          </div>
        )}
      </div>
      <div className="button-container flex flex-col gap-4 mt-6 w-full">
        <Button variant="primary" onClick={handleClose}>
          {dictionary?.close}
        </Button>
      </div>
    </div>
  );
};
